import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'clip',
  },
}));

const HeadCellShrink = ({ children, className = '' }) => {
  const classes = useStyles();

  return <div className={`${classes.root} ${className}`}>{children}</div>;
};

export default HeadCellShrink;
